export const SUPPLIER_TYPES = {
    MANUFACTURER: "MANUFACTURER",
    LABOR: "LABOR",
    MANUFACTURER_AND_LABOR: "MANUFACTURER_AND_LABOR",
} as const;

export type SupplierType = (typeof SUPPLIER_TYPES)[keyof typeof SUPPLIER_TYPES];

export const SUPPLIER_TYPE_OPTIONS = [
    { label: "Materials Distributor", value: SUPPLIER_TYPES.MANUFACTURER },
    { label: "Labor Distributor", value: SUPPLIER_TYPES.LABOR },
    { label: "Both (Materials & Labor)", value: SUPPLIER_TYPES.MANUFACTURER_AND_LABOR },
];

export interface ISupplier {
    Id: string;
    Name: string;
    Description: string;
    Email: string;
    PhoneNumber: string;
    Address: string;
    City: string;
    Country: string;
    Website: string;
    Status: "Active" | "Inactive";
    LogoUrl: string;
    Type: SupplierType | string;
}
